import React, { useEffect, useState } from 'react';
import { cleanupDuplicateFavorites } from '../services/favoriteService';
import { X, Check } from 'lucide-react';

const FavoriteDataCleanup = () => {
    const [showNotification, setShowNotification] = useState(false);
    const [cleanupResult, setCleanupResult] = useState(null);

    useEffect(() => {
        // Uygulama yüklendiğinde otomatik temizlik yap
        const performCleanup = () => {
            const lastCleanup = localStorage.getItem('favorite_cleanup_date');
            const today = new Date().toDateString();

            // Eğer bugün temizlik yapılmamışsa yap
            if (lastCleanup !== today) {
                const result = cleanupDuplicateFavorites();

                if (result.success && (result.removedFavorites > 0 || result.removedWatched > 0)) {
                    setCleanupResult(result);
                    setShowNotification(true);
                }

                // Temizlik tarihini kaydet
                localStorage.setItem('favorite_cleanup_date', today);
            }
        };

        // Biraz gecikme ile çalıştır (sayfanın yüklenmesini bekle)
        const timer = setTimeout(performCleanup, 2000);
        return () => clearTimeout(timer);
    }, []);

    const closeNotification = () => {
        setShowNotification(false);
    };

    if (!showNotification || !cleanupResult) {
        return null;
    }

    return (
        <div className="fixed top-4 right-4 z-50 max-w-md">
            <div className="bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-700 rounded-lg p-4 shadow-lg">
                <div className="flex items-start space-x-3">
                    <div className="flex-shrink-0">
                        <Check className="h-6 w-6 text-green-600 dark:text-green-400" />
                    </div>
                    <div className="flex-1">
                        <h3 className="text-sm font-medium text-green-800 dark:text-green-200 mb-1">
                            🔧 Favori Verileri Düzeltildi
                        </h3>
                        <p className="text-sm text-green-700 dark:text-green-300 mb-2">
                            Film önerilerinde yanlış favori durumu gösteren hatayı düzelttik.
                            {cleanupResult.removedFavorites > 0 && ` ${cleanupResult.removedFavorites} yanlış favori`}
                            {cleanupResult.removedWatched > 0 && ` ${cleanupResult.removedWatched} yanlış izlenen film`}
                            {' '}temizlendi.
                        </p>
                        <p className="text-xs text-green-600 dark:text-green-400">
                            Artık sadece gerçekten favorilediğiniz filmler görünecek.
                        </p>
                    </div>
                    <button
                        onClick={closeNotification}
                        className="flex-shrink-0 text-green-400 hover:text-green-600 dark:hover:text-green-300 transition-colors"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FavoriteDataCleanup; 